export const clearedFilters = {
    nr: '',
    creationDate: '',
    deadline: '',
    materialInfo: '',
    status: '',
    sort: 'nr',
    order: 'desc',
};
